function isObject(param) {
  return param && typeof param === 'object' && !Array.isArray(param);
}

export default { isObject };
